import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Classes from './components/Classes';
import Gallery from './components/Gallery';
import StudentZone from './components/StudentZone';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ComingSoon from './pages/ComingSoon';
import Profile from './pages/Profile';
import './App.css';


function Home() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Classes />
      {/* <Gallery /> */}
      <StudentZone />
      <Contact />
      <Footer />
    </div>
  );
}


// Pixels of fixed-header overlap to subtract when scrolling to a section anchor.
// Matches the offset used by Header.scrollToSection so in-page nav and hash
// navigation land in the same place.
const HEADER_OFFSET = 80;

// Single source of truth for scroll behavior on every navigation:
//   - hash present and target exists -> smooth-scroll to it (with header offset)
//   - otherwise                       -> jump to top
// Mounted inside <Router> so it sees every location change, including the same
// hash being clicked twice (location.key changes even when pathname+hash don't).
function ScrollManager() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      // Defer one frame so the route's components are laid out before measuring.
      const raf = window.requestAnimationFrame(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
          window.scrollTo({ top, behavior: 'smooth' });
        } else {
          window.scrollTo(0, 0);
        }
      });
      return () => window.cancelAnimationFrame(raf);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash, key]);

  return null;
}

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const isDevQueryParam = searchParams.get('dev') === 'true';

  useEffect(() => {
    if (isDevQueryParam) {
      localStorage.setItem('isDeveloper', 'true');
      // Remove the query param from the URL after storing it
      navigate(location.pathname, { replace: true });
    }
  }, [isDevQueryParam, navigate, location.pathname]);

  const isDeveloper = true;  // localStorage.getItem('isDeveloper') === 'true';

  if (!isDeveloper) {
    return <ComingSoon />;
  }

  return (
    <>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </>
  );
}


function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}


export default App;
